var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag"},[_vm._m(0),_c('span',[_vm._v(_vm._s(_vm._f("moment")(_vm.date,"DD.MM.YY")))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"far fa-calendar-alt"})])
}]

export { render, staticRenderFns }